import { create } from "zustand";

export type RowUploadPhase =
  | "idle"
  | "validating"
  | "uploading"
  | "removing"
  | "scanning"
  | "done";

interface SubmissionUploadState {
  activeRequirementId: string | null;
  progress: number;
  phase: RowUploadPhase;
  /** Brief green tick before scan refreshes match state. */
  justCompletedIds: string[];

  start: (requirementId: string) => void;
  setProgress: (progress: number) => void;
  setPhase: (phase: RowUploadPhase) => void;
  markDone: (requirementId: string) => void;
  reset: () => void;
  clearJustCompleted: (requirementId: string) => void;
}

export const useSubmissionUploadStore = create<SubmissionUploadState>(
  (set, get) => ({
    activeRequirementId: null,
    progress: 0,
    phase: "idle",
    justCompletedIds: [],

    start: requirementId =>
      set({
        activeRequirementId: requirementId,
        progress: 0,
        phase: "validating",
        justCompletedIds: get().justCompletedIds.filter(
          id => id !== requirementId
        ),
      }),

    setProgress: progress =>
      set({ progress: Math.min(100, Math.max(0, Math.round(progress))) }),

    setPhase: phase => set({ phase }),

    markDone: requirementId =>
      set({
        activeRequirementId: null,
        progress: 100,
        phase: "done",
        justCompletedIds: [...get().justCompletedIds, requirementId],
      }),

    reset: () =>
      set({
        activeRequirementId: null,
        progress: 0,
        phase: "idle",
      }),

    clearJustCompleted: requirementId =>
      set({
        justCompletedIds: get().justCompletedIds.filter(
          id => id !== requirementId
        ),
      }),
  })
);
